module.exports = __webpack_public_path__ + "static/media/exmpl.82d9b86b.mp4";